import WallCommon from "./wallCommon";
import {createPageToLoadArray} from "../../constants";

export default class LeftWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'left_wall';
    this.partName = 'Left Wall';
    this.dbName = 'Left Wall';
    this.translateId = "visualizer.bathroom.walls.left_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.hasAdditionalParts = true;
    this.additionalPartPartId = "left_wall_crop";
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  load(dbFeature) {
    if (dbFeature.groupName === 'Left Wall Crop') {
      if (dbFeature.metaData?.RoomLayout?.includes('10') || dbFeature.metaData?.RoomLayout?.includes('Layout10')) {
        dbFeature.metaData.ZSorting = 9.959087220921694;
      } else if (dbFeature.metaData?.RoomLayout?.includes('11') || dbFeature.metaData?.RoomLayout?.includes('11')) {
        dbFeature.metaData.ZSorting = 8.969058785788489;
      }
    }
    const partNumber = dbFeature.groupName === this.dbName ? 1 : 2;
    return super.load_(dbFeature, new LeftWall(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

}
